import { DataState } from '@bonanza-social/toolkit/state';
import { FreeSpins } from '../services/RewardsService.schemas';

export enum RewardType {
  Coins = 'Coins',
  Cash = 'Cash',
  Bonus = 'Bonus',
  FreeSpins = 'FreeSpins',
  DailyGift = 'DailyGift',
  DailyWheel = 'DailyWheel',
  InstantWheel = 'InstantWheel',
  Tokens = 'Tokens',
  Wheel = 'Wheel',
  Scratcher = 'Scratcher',
}

export type NotificationReward = {
  rewardType: RewardType;
  rewardAmount?: number;
  playerRewardId: number;
  expiryDate?: string;
  gameIds?: number[];
  status?: 'Awarded' | 'Pending' | 'NotAvailable';
  nextAvailableAt?: string;
  sourceId?: number;
};

export type Notification = {
  sourceType:
    | 'InPeriod'
    | 'DailyGift'
    | 'CommunityEventJackpotReward'
    | 'CommunityEventPlayerContributionReward'
    | 'CommunityEventPlayerMilestoneFlipReward'
    | 'ItemPurchase';
  rewards: NotificationReward[];
};

export type FreeSpinsState = {
  data: FreeSpins;
  dataState: DataState;
};

export type RewardsState = {
  freeSpins: FreeSpinsState;
};

export type RewardsLocKey = keyof RegisteredLocales['rewards'];
